import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { estruturasModuleName } from "../../shared/data.service";
import { orgaosModuleName, orgaosStorage } from "../shared/data.service";
import { Orgao } from "../shared/orgao.model";
import { Funcionario } from "../../../recursos-humanos/funcionarios/funcionario.model";
import { OrgaoNavigationService } from "../shared/orgao-navigation.service";
import { OrgaoApiService } from "../shared/orgao-api.service";
import { OrgaoService } from "../shared/orgao.service";
import { FuncionarioApiService } from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import { FuncionarioService } from "../../../recursos-humanos/funcionarios/funcionario.service";
import { PessoaNavigationService } from "../../../recursos-humanos/pessoas/shared/pessoa-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { pessoasStorage } from "../../../recursos-humanos/pessoas/shared/data.service";
import { CnpjValidator } from "../../../shared/validators/cnpj.validation";
import { Endereco } from "../../enderecos/shared/endereco.model";
import { EmailValidator } from "../../../shared/validators/email.validation";
import { PhoneValidator } from "../../../shared/validators/phone.validation";
import { EnderecoService } from "../../enderecos/shared/endereco.service";
import { funcionariosQueryComPessoa } from "../../../recursos-humanos/funcionarios/data.service";
import { TipoOrgao } from "../orgao-tipos/shared/orgao-tipo.model";
import { OrgaoTipoApiService } from "../orgao-tipos/shared/orgao-tipo-api.service";
import { OrgaoTipoNavigationService } from "../orgao-tipos/shared/orgao-tipo-navigation.service";
import { OrgaoTipoService } from "../orgao-tipos/shared/orgao.service";
import {orgaoTiposStorage, orgaoTiposQuery} from "../orgao-tipos/shared/data.service";

@Component({
    template: require('./orgao-form.component.html'),
    styles: [require('./orgao-form.component.css')]
})
export class OrgaoFormComponent implements OnInit {
    estruturasModule: any = estruturasModuleName;
    orgaosModule: any = orgaosModuleName;
    formObject: any = new Orgao();
    formObjectToSave: any = new Orgao();
    funcionarioObject: any = new Funcionario();
    tipoOrgaoObject: any = new TipoOrgao();
    enderecoObject: any = new Endereco();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    showAddress: boolean = false;

    funcionarioSelectId: string = 'funcionario';
    funcionarioQuery: any = funcionariosQueryComPessoa;
    tipoOrgaoSelectId: string = 'tipoOrgao';
    orgaoTipoQuery: string = orgaoTiposQuery;

    form: FormGroup;
    cnpj = new FormControl('', Validators.compose([Validators.required, CnpjValidator.cnpjFormat]));
    email = new FormControl('', Validators.compose([EmailValidator.emailFormat]));
    razaoSocial = new FormControl('', Validators.required);
    tipoOrgao = new FormControl('', Validators.required);
    telefone = new FormControl('', Validators.compose([PhoneValidator.phoneFormat]));
    ativo = new FormControl('');
    funcionario = new FormControl('');
    alias = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseOrgao: any;

    constructor(
        private _route: ActivatedRoute,
        private _orgaoNavigationService: OrgaoNavigationService,
        private _orgaoApiService: OrgaoApiService,
        private _orgaoService: OrgaoService,
        private _orgaoTipoApiService: OrgaoTipoApiService,
        private _orgaoTipoNavigationService: OrgaoTipoNavigationService,
        private _orgaoTipoService: OrgaoTipoService,
        private _funcionarioApiService: FuncionarioApiService,
        private _funcionarioService: FuncionarioService,
        private _pessoaNavigationService: PessoaNavigationService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _enderecoService: EnderecoService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            email: this.email,
            cnpj: this.cnpj,
            razaoSocial: this.razaoSocial,
            tipoOrgao: this.tipoOrgao,
            telefone: this.telefone,
            funcionario: this.funcionario,
            alias: this.alias
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:Orgao = this._utilService.cloneObject(this.formObject);

            if (this.funcionarioObject.id) {
                object.responsavelId = this.funcionarioObject.id;
            }

            if (this.tipoOrgaoObject.id) {
                object.tipoOrgaoId = this.tipoOrgaoObject.id;
            }

            if (object.telefone) {
                object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
            }

            if (object.cnpj) {
                object.cnpj = this._utilService.removeSpecialCharacter(object.cnpj);
            }

            this.formObjectToSave = object;
            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
        }
    }

    getFuncionariosObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._orgaoService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                nome: object.text,
                isFuncionario: true,
                form: orgaosStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, pessoasStorage);
            this._pessoaNavigationService.goToNew();
        } else {
            this.funcionarioObject = object;
            if (object.id) {
                this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'funcionario', {id: -1});
            }
        }
    }

    funcionarioTemplateResult = (function(state: any) {
        var template: any = this._funcionarioService.templateResult(state, true);
        return template;
    }.bind(this));

    getTipoOrgaoObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._orgaoService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                descricao: object.text,
                form: orgaosStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, orgaoTiposStorage);
            this._orgaoTipoNavigationService.goToNew();
        } else {
            this.tipoOrgaoObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'tipoOrgao', object);
        }
    }

    tipoOrgaoTemplateResult = (function(state: any) {
        var template: any = this._orgaoTipoService.templateResult(state, true);
        return template;
    }.bind(this));

    private onDoneEndereco = (function (Response: any) {
        if (!Response.error)  {
            var addressId: number = Response.id;

            this.formObjectToSave.enderecoId = addressId;
            if (this.formObject.id) {
                this.onEditOrgao();
            } else {
                this.onAddOrgao();
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private onAddOrgao() {
        this._orgaoApiService.onPost(this.formObjectToSave, this.onDone);
    }

    private onEditOrgao() {
        this._orgaoApiService.onPut(this.formObjectToSave, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseOrgao = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();

            } else {
                this._utilService.swalMessageWarningCustom('Nenhum órgão encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._orgaoApiService.onGetById(id, onDone);
    }

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.responsavel = this.funcionarioObject;
        object.tipoOrgao = this.tipoOrgaoObject;
        object.endereco = this.enderecoObject;

        return object;
    }

    private testSession() {
        var id: number;
        var session: any = this._orgaoService.getSessionStorage();
        this._orgaoService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
        this.showAddress = true;
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(orgaosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.razaoSocial = newAutoComplete.razaoSocial;

            this.setActionTitle(this.formObject.id);
            this.showAddress = true;
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setModelToForm() {
        if (this.formObject.tipoOrgao) {
            this.tipoOrgaoObject = this._utilService.cloneObject(this.formObject.tipoOrgao);
            delete this.formObject['tipoOrgao'];

            var text: string = this._autocompleteService.getTextSelect2(this.tipoOrgaoObject, 'descricao');
            text = this._orgaoTipoService.templateText(this.tipoOrgaoObject);
            var selectObject:any = {text: text, id: this.tipoOrgaoObject.id};

            this._autocompleteService.createOptionOnSelect2(this.tipoOrgaoSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.tipoOrgaoSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'tipoOrgao', this.tipoOrgaoObject);
        }

        if (this.formObject.responsavel) {
            this.funcionarioObject = this._utilService.cloneObject(this.formObject.responsavel);
            delete this.formObject['responsavel'];

            if (this.funcionarioObject.pessoa) {
                var selectObject:any = {text: this.funcionarioObject.pessoa.nome, id: this.funcionarioObject.id};

                this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
            }
        }

        if (this.formObject.endereco) {
            this.enderecoObject = this.formObject.endereco;
            delete this.formObject['endereco'];
        }

        this.showAddress = true;
    }

    private goToList() {
        this._orgaoNavigationService.goToList();
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._orgaoService.returnToOtherForm(this.otherForm, this.responseOrgao);
        } else {
            this.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-form/orgao-form.component.ts
 **/